import { Button, IconButton, Stack } from '@mui/material';

export const VXButtons = ({
  onApprove,
  onCancel,
  approveDisabled,
}: {
  onApprove: () => void;
  onCancel: () => void;
  approveDisabled?: boolean;
}) => {
  return (
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Button
        data-testid='v-btn'
        disabled={approveDisabled}
        onClick={() => {
          onApprove();
        }}
        variant='contained'
        className='min-w-[20px]! p-[6px]'
      >
        <i className={'material-symbols-check w-[20px] h-[20px]'} />
      </Button>
      <IconButton
        data-testid='x-btn'
        onClick={() => {
          onCancel();
        }}
      >
        <i
          className={
            'material-symbols-close-rounded w-[20px] h-[20px] text-(--mui-palette-text-primary)'
          }
        />
      </IconButton>
    </Stack>
  );
};
